import { BaseError } from '../error';
export class ContextError extends BaseError {
    constructor(message, cause) {
        super(message, cause);
    }
}
export class ContextStateError extends ContextError {
    constructor(message, cause) {
        super(message, cause);
    }
}
export class ContextLoadError extends ContextError {
    constructor(message, cause) {
        super(message, cause);
    }
}
export class ContextReloadError extends ContextError {
    constructor(message, cause) {
        super(message, cause);
    }
}
export class MissingContextValue extends ContextError {
    constructor(message, key, cause) {
        super(message, cause);
        this.key = key;
    }
}
export var StandardUrlNames;
(function (StandardUrlNames) {
    StandardUrlNames["CANONICAL"] = "CANONICAL";
    StandardUrlNames["USER_FRIENDLY"] = "USER_FRIENDLY";
})(StandardUrlNames || (StandardUrlNames = {}));
export const ZETAPUSH_HTTP_SERVER = 'ZETAPUSH_HTTP_SERVER';
export const CURRENT_WORKER_NAME = undefined;
//# sourceMappingURL=context.js.map